export default __webpack_public_path__ + "static/media/ic_success_orange.24dbe6a9.svg";